export default __webpack_public_path__ + "static/1-1-0-0-f24ad5e9c69c745406f8bdeded7979b5.jpg";